var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip-group',{attrs:{"active-class":"primary--text","column":""}},_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag},[_vm._v(" "+_vm._s(tag)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }